<template>
  <div style="align-items: center;justify-content: center;padding-top: 80px;padding-bottom: 80px" class="column-view">
    <img src="@/assets/logo/no_content.png" style="width: 190px;height: 160px" v-if="show_image">

    <div class="default-title-15-99" style="margin-top: 20px">{{ des }}</div>

    <el-button v-if="show_button" style="margin-top:20px" type="primary"  size="mini" @click="onButtonClick">{{button_des}}</el-button>
  </div>
</template>

<script>
export default {
  name: "YcNoContent",
  data() {
    return {}
  },
  methods:{
    onButtonClick(){
      this.$emit('onButtonClick')
    }

  },

  props: {
    des: {
      type: String,
      default: '没有任何数据哦~'
    },

    show_button:{
      type:Boolean,
      default:false
    },
    button_des:{
      type:String,
      default:''
    },
    show_image:{
      type:Boolean,
      default:true
    }
  }
}


</script>

<style scoped>

</style>
